<template>
  <v-card class="lesson-overview">
    <div>
      <v-btn
        fab
        small
        absolute
        top
        right
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-container id="dropdown-example" fill-height>
        <v-row class="mb-2">
          <v-col cols="12">
            <div
              class="line-separator"
              v-for="(message, index) in customClass.messages"
              :key="'msg-' + index"
            >
              <v-card class="relative" flat key="notEdit">
                <v-card-title class="title pb-0">
                  {{ message.title }}
                </v-card-title>
              </v-card>
              <v-card-text>{{ message.messages }}</v-card-text>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row justify="end">
              <v-btn
                dark
                color="secondary"
                class="primary--text"
                @click="goToLessons"
              >
                go to my {{ lessonTerm }}s
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'ClassMessages',
  props: {
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {}
  },
  async mounted() {},
  computed: {
    ...mapState(['lessonTerm'])
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    ...mapGetters('entities/classes', ['currentClassId']),
    goToLessons() {
      this.$emit('goToLessons')
    }
  }
}
</script>

<style lang="scss">
.lesson-overview {
  box-shadow: none;

  .message-box {
    padding: 20px;
    background-color: white;
    border: solid 1px white;
  }
}
</style>
